import { AuditLogEvent } from '@seapoint/server/enums';
import { toast } from 'sonner';

type HandleAuditLogEventArgs = {
  type: AuditLogEvent;
  message: string;
  isError: boolean;
};

// Events that should display toast notifications to users
const EVENTS_WITH_TOAST = new Set<AuditLogEvent>([
  AuditLogEvent.ACCOUNT_AND_TRANSACTION_SYNC,
  AuditLogEvent.AI_PIPELINE,
  AuditLogEvent.EMAIL_INVOICE_EXTRACTOR,
  AuditLogEvent.EMAIL_INVOICE_PROCESSOR,
  AuditLogEvent.OAUTH_CONNECTION_FAILED,
]);

export const handleAuditLogEvent = ({ type, message, isError }: HandleAuditLogEventArgs) => {
  if (EVENTS_WITH_TOAST.has(type)) {
    if (isError) {
      toast.error(message);
    } else {
      toast.info(message);
    }
  }
};
